// FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'

function Venue13(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 250 250"
            {...props}
        >
            <defs>
                <style>
                    {
                        '\n            .cls-1 {\n                fill: #5b5b5b;\n            }\n\n            .cls-2 {\n                fill: #7f7f7f;\n            }\n\n            .cls-3 {\n                fill: #ffec5f;\n            }\n\n            .st6 {\n                fill: #a98c48;\n            }\n\n            .st3,\n            .st4 {\n                fill: #68836a;\n            }\n\n            .st4 {\n                font-size: 11px;\n                font-family: ArialMT, Arial;\n            }\n        '
                    }
                </style>
            </defs>
            <title>13</title>
            <g id="TEX_-_13" data-name="TEX - 13">
                <g id="Compass_copy_8" data-name="Compass copy 8">
                    <g id="compass">
                        <polygon
                            className="cls-1"
                            points="232.2 192.24 228.3 200.52 222.54 206.09 225.62 198.68 232.2 192.24"
                        />
                        <path
                            className="cls-2"
                            d="M235.79,186.73a15.51,15.51,0,1,1-21.56,4A15.52,15.52,0,0,1,235.79,186.73ZM219,211.22a14.19,14.19,0,1,0-3.67-19.72A14.2,14.2,0,0,0,219,211.22Z"
                        />
                        <circle
                            className="cls-1"
                            cx={227.02}
                            cy={199.52}
                            r={2.97}
                            transform="translate(-32.67 44.9) rotate(-10.54)"
                        />
                        <path
                            className="cls-1"
                            d="M222.77,207.85,221,210.39l-.39-.27,0-2.55h0l-1.2,1.75L219,209l1.74-2.54.39.27,0,2.56h0l1.21-1.76Z"
                        />
                        <circle
                            className="cls-3"
                            cx={227.02}
                            cy={199.52}
                            r={1.65}
                            transform="translate(-32.68 44.91) rotate(-10.54)"
                        />
                    </g>
                </g>
                <path
                    id="outfield"
                    className="st6"
                    d="M27.36,108.91l.06-14L71.18,42.24,90.56,31.45l67.28-.3,16,13.56h8.52l43.12,47.64L224,109.26l-16.59,16.92-1.58,2.32s-57.18,84.47-63.13,92c-8.74,11-21.62,12.66-32.25.48C99,207.72,51.34,145.42,43.64,133.88l.72-3.37Z"
                />
                <path
                    id="grass"
                    className="st3"
                    d="M36.58,109.13V95.9l38.7-48.66L93.72,36.89l58.89-.3,15.33,12.8h6.5l43.75,47.41-2.95,12.94-16.32,17.51-.72,2.41s-54.61,77.46-60.14,84.67-13.71,14.43-21.41,4.09S50,131.83,50,131.83v-4.57Z"
                />
                <g id="infield_sand_copy_2" data-name="infield sand copy 2">
                    <path
                        className="st6"
                        d="M164.34,168.49s-12-31-38.82-30.83c-27.29.18-39.38,30.1-39.38,30.1l32.46,31.15c-1.2,1.06-1.63,3.33-1.63,4.53a8.17,8.17,0,0,0,16.34,0,7.77,7.77,0,0,0-1.1-4Zm-43.59,26.67-17.67-17.71c1.14-1.37,3.31-3.3,3.31-5.2a7.76,7.76,0,0,0-.49-2.69l14.58-14.19c1.34.94,2.9,1,4.68,1s3.36,0,4.67-.83l14.54,14.16a7.75,7.75,0,0,0-.46,2.6c0,1.88,2.49,3.84,3.61,5.2l-18.18,17.66Z"
                    />
                </g>
                <g id="distances">
                    <text
                        className="st3 st4 st5"
                        transform="translate(10.24 88.03)"
                    >
                        332
                    </text>
                    <text
                        className="st3 st4 st5"
                        transform="translate(48.45 42.27)"
                    >
                        390
                    </text>
                    <text
                        className="st3 st4 st5"
                        transform="translate(115.3 26.26)"
                    >
                        400
                    </text>
                    <text
                        className="st3 st4 st5"
                        transform="translate(162.94 31.15)"
                    >
                        407
                    </text>
                    <text
                        className="st3 st4 st5"
                        transform="translate(198.56 58.23)"
                    >
                        381
                    </text>
                    <text
                        className="st3 st4 st5"
                        transform="translate(228.67 94.68)"
                    >
                        325
                    </text>
                </g>
            </g>
            <g id="Pitchers_mound" data-name="Pitchers mound">
                <g id="mound_2_">
                    <path
                        id="pitching-mound_2_"
                        className="st6"
                        d="M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
                    />
                    <rect
                        id="pitching-rubber_2_"
                        x={123.2}
                        y={176.6}
                        className="st7"
                        width={4}
                        height={1.6}
                    />
                </g>
            </g>
            <g
                id="Bases_and_chalk_lines-ALL"
                data-name="Bases and chalk lines-ALL"
            >
                <rect
                    className="st7"
                    x={123.17}
                    y={176.68}
                    width={3.98}
                    height={1.55}
                />
                <rect
                    className="st7"
                    x={98.41}
                    y={174.55}
                    width={3.04}
                    height={3.04}
                    transform="translate(-95.22 122.19) rotate(-44.99)"
                />
                <rect
                    className="st7"
                    x={148.89}
                    y={174.55}
                    width={3.04}
                    height={3.04}
                    transform="translate(-80.45 157.87) rotate(-44.99)"
                />
                <rect
                    className="st7"
                    x={123.65}
                    y={149.32}
                    width={3.04}
                    height={3.04}
                    transform="translate(-70 132.73) rotate(-45.01)"
                />
                <polygon
                    className="st7"
                    points="126.7 201.88 125.16 203.41 123.65 201.88 123.65 200.36 126.7 200.36 126.7 201.88"
                />
                <g id="lines">
                    <path
                        id="left-foul-line"
                        className="st8"
                        d="M125.2 203.2l-97.1-97.1"
                    />
                    <path
                        id="right-foul-line"
                        className="st8"
                        d="M125.2 203.2l97.1-97.2"
                    />
                </g>
            </g>
        </svg>
    )
}
export default Venue13
